/**
 * Helpers pour générer des JSON-LD BreadcrumbList compatibles Schema.org.
 * Améliore les rich snippets Google (chemin de navigation dans les résultats).
 */

const SITE_URL =
  (typeof process !== 'undefined' && process.env && process.env.REACT_APP_SITE_URL) ||
  (typeof window !== 'undefined' && window.location?.origin) ||
  'https://code2roues.fr';

/**
 * Génère un breadcrumb JSON-LD à partir d'une liste de paires [label, path].
 * Le premier item est toujours « Accueil » (path = '/').
 *
 * @example
 *   buildBreadcrumb([
 *     ['Programme ETM', '/programme-etm'],
 *   ])
 */
export function buildBreadcrumb(items = []) {
  const all = [['Accueil', '/'], ...items];
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    'itemListElement': all.map(([name, path], idx) => ({
      '@type': 'ListItem',
      'position': idx + 1,
      'name': name,
      'item': `${SITE_URL}${path}`,
    })),
  };
}

/**
 * Combine plusieurs JSON-LD en un seul array compatible.
 */
export function combineJsonLd(...nodes) {
  return nodes.filter(Boolean).flatMap((n) => (Array.isArray(n) ? n : [n]));
}
